import { render, staticRenderFns } from "./Disappears.vue?vue&type=template&id=0f798723&scoped=true"
import script from "./Disappears.vue?vue&type=script&lang=js"
export * from "./Disappears.vue?vue&type=script&lang=js"
import style0 from "./Disappears.vue?vue&type=style&index=0&id=0f798723&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f798723",
  null
  
)

export default component.exports